import { render } from "./WCSimpleActionableToast.vue?vue&type=template&id=3004d768&scoped=true"
import script from "./WCSimpleActionableToast.vue?vue&type=script&lang=js"
export * from "./WCSimpleActionableToast.vue?vue&type=script&lang=js"

import "./WCSimpleActionableToast.vue?vue&type=style&index=0&id=3004d768&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3004d768"]])

export default __exports__